module.exports = __webpack_public_path__ + "img/12.87084176.png";